import styled from 'styled-components';

//helpers
import {textFontSizes} from '../../styles/vars';
import {commonPalette} from '../../styles/palette';
import {textStyles} from '../../styles/typefaces';

export const textColors = {
  primary: commonPalette.textPrimary,
  secondary: commonPalette.textSecondary,
  brand: commonPalette.textBrand,
  inverse: commonPalette.textInverse
} as const;

export type TextColor = keyof typeof textColors;

export type TextType = keyof typeof textStyles.desktop;

export type TextPlatform = keyof typeof textStyles;

type TextProps = {
  size?: 'small' | 'normal' | 'large';
  device?: 'desktop' | 'mobile';
  ellipsis?: boolean;
  secondary?: boolean;
  opacity?: number;
  platform?: TextPlatform;
  textType?: TextType;
  textColor?: TextColor;
};

const fontSizing = ({size = 'normal', device}: TextProps) =>
  device &&
  `
  font-size: ${textFontSizes[size][device]}rem;
  line-height: 1.5;
`;

export const Text = styled.div<TextProps>`
  ${fontSizing}

  ${({platform = 'desktop', textType}) => textType && textStyles[platform][textType]}

  ${p => p.textColor && `color: ${textColors[p.textColor]};`}

  ${p =>
    p.ellipsis &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `};

  ${p =>
    p.secondary &&
    `
    opacity: 0.5;
  `};

  ${p =>
    p.opacity &&
    `
    opacity: ${p.opacity};
  `};
`;
